/*
 * Copyright (c) 2026 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { CashRegisterDetailsAction, CashRegisterDetailsActionType } from 'data/actions/cashRegisterDetailsActions';
import {
    CashRegisterDto,
    InitOtpResponseDto,
    CashRegisterStatusHistoryPage,
} from 'data/api/cashRegister/cashRegistersClient.typings';
import { PageQueryParams } from 'data/api/apiCommon.typings';

export const rowsPerPage = [20, 30, 40];
export const defaultPaginationLimit = rowsPerPage[0];

export interface CashRegisterDetailsState {
    factoryNumber: string;
    cashRegister: CashRegisterDto;
    initOtp: InitOtpResponseDto;
    statusHistory: CashRegisterStatusHistoryPage;
    statusHistoryPageParams: PageQueryParams;
    isLoading: boolean;
    isLoadingInitOtp: boolean;
    isLoadingStatusHistory: boolean;
}

const initialState: CashRegisterDetailsState = {
    factoryNumber: null,
    cashRegister: null,
    initOtp: null,
    statusHistory: null,
    statusHistoryPageParams: {
        limit: defaultPaginationLimit,
        offset: 0,
    },
    isLoading: false,
    isLoadingInitOtp: false,
    isLoadingStatusHistory: false,
};

export function cashRegisterDetailsReducer(
    state: CashRegisterDetailsState = initialState,
    action: CashRegisterDetailsAction,
): CashRegisterDetailsState {
    switch (action.type) {
        case CashRegisterDetailsActionType.OPEN_REGISTRY_CASH_REGISTER_CARD_PAGE:
            const previousFactoryNumber = state.factoryNumber;
            const currentFactoryNumber = action.payload;

            let isNewCardOpen = true;
            if (previousFactoryNumber && currentFactoryNumber)
                isNewCardOpen = previousFactoryNumber !== currentFactoryNumber;

            return {
                ...state,
                isLoading: true,
                factoryNumber: action.payload,
                initOtp: initialState.initOtp,
                statusHistoryPageParams: isNewCardOpen
                    ? initialState.statusHistoryPageParams
                    : { ...state.statusHistoryPageParams },
                statusHistory: isNewCardOpen ? initialState.statusHistory : state.statusHistory,
            };

        case CashRegisterDetailsActionType.FETCH_CASH_REGISTER_DETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                cashRegister: action.payload,
            };

        case CashRegisterDetailsActionType.CREATE_INIT_OTP:
            return {
                ...state,
                isLoadingInitOtp: true,
            };

        case CashRegisterDetailsActionType.CREATE_INIT_OTP_SUCCESS:
            return {
                ...state,
                isLoadingInitOtp: false,
                initOtp: action.payload,
            };

        case CashRegisterDetailsActionType.FETCH_CASH_REGISTER_STATUS_HISTORY:
            return {
                ...state,
                isLoadingStatusHistory: true,
            };

        case CashRegisterDetailsActionType.FETCH_CASH_REGISTER_STATUS_HISTORY_SUCCESS:
            return {
                ...state,
                isLoadingStatusHistory: false,
                statusHistory: action.payload,
            };

        case CashRegisterDetailsActionType.FETCH_CASH_REGISTER_CARD_DATA_ERROR:
            return {
                ...state,
                isLoading: false,
                isLoadingInitOtp: false,
                isLoadingStatusHistory: false,
            };

        case CashRegisterDetailsActionType.EXIT_REGISTRY_CASH_REGISTER_CARD_PAGE:
            return {
                ...state,
                cashRegister: null,
                initOtp: null,
                statusHistory: null,
                statusHistoryPageParams: initialState.statusHistoryPageParams,
            };

        default:
            break;
    }

    return state;
}
